import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DocmanFileModel } from '../services/docman.model.file';
import { UiService } from '../../../core/services/core.ui.service';

@Component({
  selector: 'file-version-modal',
  template: require('./file.version.restore.modal.html')
})
export class FileVersionRestoreModalComponent implements OnInit {
  @Input() fileVersion: any;

  @Output() onRestore = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  constructor(
    private docmanFileModel: DocmanFileModel,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
  }

  restoreFileVersion(): void {
    this.docmanFileModel.restoreFileVersion(this.fileVersion).then(
      (response) => {
        this.uiService.message.showSuccess(`Version ${this.fileVersion.versionNumber} of file "${this.fileVersion.filesystem.fileName}" has been restored successfully`);
        this.onRestore.emit(response);
      },
      () => {
        this.uiService.message.showError(`Version ${this.fileVersion.versionNumber} of file "${this.fileVersion.filesystem.fileName}" restore has failed`);
        this.onClose.emit();
      }
    );
  }
}
